import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Container, Paper, Button, TextField, Grid, Alert, RadioGroup, FormControlLabel, Radio, FormControl, FormLabel } from '@mui/material';
import { Save } from '@mui/icons-material';
import { printSettingsService } from '../../services/api';
import TopBar from '../../components/TopBar';

const PrintSettings = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ letterheadType: 'Pre-Printed Letterhead', hospitalName: 'Vedanta Hospital', address: '', phone: '', headerText: '', footerText: '', marginTop: 10, marginBottom: 10, marginLeft: 10, marginRight: 10 });
  const [success, setSuccess] = useState('');

  useEffect(() => { loadSettings(); }, []);

  const loadSettings = async () => {
    try {
      const response = await printSettingsService.getSettings();
      const d = response.data;
      if (d) {
        setFormData({
          letterheadType: d.letterheadType || d.LetterheadType || 'Pre-Printed Letterhead',
          hospitalName:  d.hospitalName  || d.HospitalName  || '',
          address:       d.address       || d.Address       || '',
          phone:         d.phone         || d.Phone         || '',
          headerText:    d.headerText    || d.HeaderText    || '',
          footerText:    d.footerText    || d.FooterText    || '',
          marginTop:     d.marginTop     ?? d.MarginTop     ?? 10,
          marginBottom:  d.marginBottom  ?? d.MarginBottom  ?? 10,
          marginLeft:    d.marginLeft    ?? d.MarginLeft    ?? 10,
          marginRight:   d.marginRight   ?? d.MarginRight   ?? 10,
        });
      }
    } catch (err) {
      console.error('Failed to load settings');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await printSettingsService.updateSettings(formData);
      setSuccess('Settings updated successfully!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Failed to update settings');
    }
  };

  const isPrePrinted = formData.letterheadType === 'Pre-Printed Letterhead';

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <TopBar title="Print Settings" onBack={() => navigate('/dashboard')} />
      <Container maxWidth="md" sx={{ py: 4 }}>
        {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>Configure Print Layout</Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>Letterhead Type</FormLabel>
                  <RadioGroup
                    row
                    value={formData.letterheadType}
                    onChange={(e) => setFormData({ ...formData, letterheadType: e.target.value })}
                  >
                    <FormControlLabel value="Pre-Printed Letterhead" control={<Radio />} label="Pre-Printed Letterhead" />
                    <FormControlLabel value="Digital Letterhead" control={<Radio />} label="Digital Letterhead" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12}><TextField fullWidth label="Hospital Name" value={formData.hospitalName} onChange={(e) => setFormData({...formData, hospitalName: e.target.value})} disabled={isPrePrinted} /></Grid>
              <Grid item xs={12}><TextField fullWidth label="Address" value={formData.address} onChange={(e) => setFormData({...formData, address: e.target.value})} multiline rows={2} disabled={isPrePrinted} /></Grid>
              <Grid item xs={12}><TextField fullWidth label="Phone" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} disabled={isPrePrinted} /></Grid>
              <Grid item xs={12}><TextField fullWidth label="Header Text" value={formData.headerText} onChange={(e) => setFormData({...formData, headerText: e.target.value})} disabled={isPrePrinted} /></Grid>
              <Grid item xs={12}><TextField fullWidth label="Footer Text" value={formData.footerText} onChange={(e) => setFormData({...formData, footerText: e.target.value})} disabled={isPrePrinted} /></Grid>
              <Grid item xs={6}><TextField fullWidth label="Margin Top (mm)" type="number" value={formData.marginTop} onChange={(e) => setFormData({...formData, marginTop: e.target.value})} /></Grid>
              <Grid item xs={6}><TextField fullWidth label="Margin Bottom (mm)" type="number" value={formData.marginBottom} onChange={(e) => setFormData({...formData, marginBottom: e.target.value})} /></Grid>
              <Grid item xs={6}><TextField fullWidth label="Margin Left (mm)" type="number" value={formData.marginLeft} onChange={(e) => setFormData({...formData, marginLeft: e.target.value})} /></Grid>
              <Grid item xs={6}><TextField fullWidth label="Margin Right (mm)" type="number" value={formData.marginRight} onChange={(e) => setFormData({...formData, marginRight: e.target.value})} /></Grid>
              <Grid item xs={12}><Button type="submit" fullWidth variant="contained" size="large" startIcon={<Save />}>Save Settings</Button></Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default PrintSettings;
